import { AppConfig } from 'src/app/app-config';

export const environment: AppConfig = {
  production: false,
  serviceWorker: true,
  authApiURI: 'https://demo-auth.talentpoint.pl/api',
  resourceApiURI: 'https://demo-api.talentpoint.pl/api',
  authority: 'https://demo-auth.talentpoint.pl',
  client_id: 'angularHRDP',
  redirect_uri: 'https://demo.talentpoint.pl/auth-callback',
  post_logout_redirect_uri: 'https://demo.talentpoint.pl/',
  response_type: 'code',
  scope: 'openid profile email offline_access hrdp.api.read',
  filterProtocolClaims: true,
  loadUserInfo: true,
  automaticSilentRenew: true,
  useRefreshToken: true,
  silent_redirect_uri: 'https://demo.talentpoint.pl/silent-refresh.html',
  cmsApiURI: 'http://localhost:1337/api',
  resourceApiCacheExpirationTimeSec: 120,
  simplysignApiURI: 'https://model.simplysign.webnotarius.pl',
  simplySignResponseType: 'code',
  simplySignClientId: 'fUeskHz92YCyf647UNQU',
  simplySignRedirectUri: 'http://demo.talentpoint.pl/auth-callback',
  noActiveUserTTL: 900000,
  noActiveUserMessageTTLLimit: 60000,
  renewTimeBeforeTokenExpiresInSeconds: 360,
  checkUpdatesEverySeconds: 600,
  baseUrl: 'https://demo.talentpoint.pl/',
  refreshTokenRetryInSeconds: 5,
  tokenRefreshInSeconds: 30
};
